import * as actions from "../action.constants";

export const verifyEmail = (payload, callback) => ({
  type: actions.VERIFY_EMAIL,
  payload,
  callback,
});

export const verifyToken = (payload, callback) => ({
  type: actions.VERIFY_TOKEN,
  payload,
  callback,
});

export const resetPassword = (payload, callback) => ({
  type: actions.RESET_PASSWORD,
  payload,
  callback,
});
